import { getQualifiedResourcesPost } from '@dispatch/shared/services';
import { usePaginatedQuery } from '../api/usePaginatedQuery';
import { QualifiedResourcesFNOLFilters } from '@dispatch/shared/types';

export const useGetQualifiedResourcesPost = (
  filters?: QualifiedResourcesFNOLFilters,
  enabled?: boolean
) => {
  return usePaginatedQuery(
    ['resources-as-post', filters],
    (token) => getQualifiedResourcesPost(filters, token),
    {
      enabled,
    }
  );
};
